import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import FocusGroupProvider from './FocusGroupManager.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import './FocusGroup.js';
import 'hotkeys-js';
import './FocusGroupContext.js';

function FocusGroupHoc(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (_ref) {
    var onExitFocusGroup = _ref.onExitFocusGroup,
        onFocusPrevGroup = _ref.onFocusPrevGroup,
        focusKeyBindings = _ref.focusKeyBindings,
        props = _objectWithoutProperties(_ref, ["onExitFocusGroup", "onFocusPrevGroup", "focusKeyBindings"]);

    return /*#__PURE__*/React.createElement(FocusGroupProvider, _extends({
      keyBindings: focusKeyBindings,
      onExitFocusGroup: onExitFocusGroup,
      onFocusPrevGroup: onFocusPrevGroup
    }, options), /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, options)));
  };
}

export default FocusGroupHoc;
//# sourceMappingURL=focusGroupManagerHoc.js.map
